module.exports = __webpack_public_path__ + "static/media/EDHLife_Overview.e023faa3.png";